import { useState, useMemo } from 'react'
import { allArticulos } from '../data'

export function useGlobalSearch() {
  const [query, setQuery] = useState('')
  const resultados = useMemo(() => {
    const q = query.trim().toLowerCase()
    if (!q) return []
    return allArticulos.filter(a =>
      a.titulo.toLowerCase().includes(q) ||
      (a.descripcion && a.descripcion.toLowerCase().includes(q))
    )
  }, [query])
  return { query, setQuery, resultados }
}